import React, {Component} from 'react';

class About extends React.Component {
    render() {
        return(
            <div className="container">
                <div className="row">
                    <div className="col-10">
                        <p>About Medli</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js